import React, { Component } from 'react'
import { Row, Col, Container } from "react-bootstrap";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch"
import MaterialDetailsModal from './MaterialDetailsModal';
import MaterialTabs from '../MaterialTabs';
import { MaterialPageShimmer, MaterialTableShimmer } from '../MaterialShimmer';
import "./_materialCreation.scss";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";


const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_MATERIAL_TYPES = gql`
  query($id:Int){
    getMaterialTypes(id:$id){
      id
      material_type
    }
  }
`;

const GET_MATERIAL_REPORT = gql`
  query($institute_id:Int,$branch_id:Int,$class_id:String,$section_id:String,$material_type_id:Int){
    getMaterialReport(institute_id:$institute_id,branch_id:$branch_id,class_id:$class_id,section_id:$section_id,material_type_id:$material_type_id){
      total_students{ student_id student_name roll_no ecs materials{ material_id material_name } materials_delivered{ material_id material_name delivOrRecvDate } materials_received{ material_id material_name delivOrRecvDate } materials_pending{ material_id material_name delivOrRecvDate } materials_not_received{ material_id material_name delivOrRecvDate } }
      fully_deliv_students{ student_id student_name roll_no ecs materials{ material_id material_name } materials_delivered{ material_id material_name delivOrRecvDate } materials_received{ material_id material_name delivOrRecvDate } materials_pending{ material_id material_name delivOrRecvDate } materials_not_received{ material_id material_name delivOrRecvDate } }
      partly_deliv_students{ student_id student_name roll_no ecs materials{ material_id material_name } materials_delivered{ material_id material_name delivOrRecvDate } materials_received{ material_id material_name delivOrRecvDate } materials_pending{ material_id material_name delivOrRecvDate } materials_not_received{ material_id material_name delivOrRecvDate } }
      not_deliv_students{ student_id student_name roll_no ecs materials{ material_id material_name } materials_delivered{ material_id material_name delivOrRecvDate } materials_received{ material_id material_name delivOrRecvDate } materials_pending{ material_id material_name delivOrRecvDate } materials_not_received{ material_id material_name delivOrRecvDate } }
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) { super(props); this.state = { open: false }; this.ref = React.createRef(); }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => { if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false }); };
    toggle = (id) => { const { value, onChange } = this.props; onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]); };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0 ? placeholder : value.length === options.length ? `All (${options.length})` : value.length === 1 ? (options.find((o) => o.value === value[0])?.label || `${value.length} selected`) : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })} style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 42 }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 240, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))} style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)} style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const FIN = {
    wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
    card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
    cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
    iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
    cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
    cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
    cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
    filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
    label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
    select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
    btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
    content: { padding: "20px 24px" },
};

class MaterialReportHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            getClasses: [],
            materialTypeDetails: [],
            classSearch: [],
            classError: "",
            sectionSearch: [],
            sectionError: "",
            materialTypeSearch: "0",
            materialTypeError: "",
            loader: 0,
            blockType: "1",
            dashboard: false,
            materialDetailsModal: false,
            rowData: [],
            selctedType: "",
            totalStudentsData: [],
            initialLoad: true,
        };
    }

    async componentDidMount() {
        await this.loadFilters();
        // Branch comes from the header (NavbarOne) — re-scope when it changes.
        this.offBranchScope = onBranchScopeChange(() => this.loadFilters());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    loadFilters = async () => {
        try {
            const [branchesRes, classesRes, typesRes] = await Promise.all([
                this.props.client.query({ query: GET_BRANCHES, variables: { institution_id: parseInt(Cookies.get("institutionid")) }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_CLASSES, variables: { id: 1 }, fetchPolicy: "network-only" }),
                this.props.client.query({ query: GET_MATERIAL_TYPES, variables: { id: 0 }, fetchPolicy: "network-only" }),
            ]);
            // The header's branch selection IS this page's branch filter, and it never
            // widens past the branches the user is authorized for.
            const branches = scopeBranches(branchesRes.data.getBranches || []);
            this.setState({
                branches,
                getClasses: classesRes.data.getExamClasses || [],
                materialTypeDetails: typesRes.data.getMaterialTypes || [],
                initialLoad: false,
                // Class/Section options are rebuilt from the new branch set, so drop any
                // selection that no longer belongs to a branch in scope.
                classSearch: [], sectionSearch: [], totalStudentsData: [], dashboard: false, blockType: "1",
            });
        } catch (err) {
            console.error("material report load error", err);
            this.setState({ initialLoad: false });
        }
    }

    // Class / Section options now span every branch the header has in scope,
    // instead of the one branch a local dropdown used to pick.
    scopedSections = () => this.state.branches.flatMap(b => b.sections || []);

    classOptions = () => {
        const classIds = [...new Set(this.scopedSections().map(s => Number(s.class_id)))];
        return classIds.map(cid => this.state.getClasses.find(c => c.id === cid)).filter(Boolean).map(c => ({ value: c.id, label: c.class }));
    };

    sectionOptionsFor = (classIds) => {
        return this.scopedSections()
            .filter(s => classIds.length === 0 || classIds.map(Number).includes(Number(s.class_id)))
            .map(s => ({ value: s.id, label: s.section_name }));
    };

    onClassChange = (classIds) => {
        const sectionIds = this.sectionOptionsFor(classIds).map(o => o.value);
        this.setState({ classSearch: classIds, sectionSearch: sectionIds, classError: "", totalStudentsData: [], dashboard: false, blockType: "1" });
    };

    onSectionChange = (sectionIds) => {
        this.setState({ sectionSearch: sectionIds, sectionError: "", totalStudentsData: [], dashboard: false, blockType: "1" });
    };

    onMaterialTypeChange = (e) => {
        this.setState({ materialTypeSearch: e.target.value, materialTypeError: "", totalStudentsData: [], dashboard: false, blockType: "1" });
    };

    handleSubmit = async () => {
        if (!this.state.classSearch.length) { this.setState({ classError: "Please Select Class" }); return; }
        if (!this.state.sectionSearch.length) { this.setState({ sectionError: "Please Select Section" }); return; }
        if (this.state.materialTypeSearch === "0") { this.setState({ materialTypeError: "Please Select Material Type" }); return; }

        // The service takes a single branch_id, so the header's branch scope is
        // fanned out and the four student buckets concatenated.
        const branchIds = this.state.branches.map(b => parseInt(b.id)).filter(id => !isNaN(id));
        if (!branchIds.length) { this.setState({ totalStudentsData: [], loader: 0, dashboard: true }); return; }

        this.setState({ loader: 1 });
        try {
            const results = await Promise.all(branchIds.map(branch_id => this.props.client.query({
                query: GET_MATERIAL_REPORT,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id,
                    class_id: this.state.classSearch.join(","),
                    section_id: this.state.sectionSearch.join(","),
                    material_type_id: parseInt(this.state.materialTypeSearch),
                },
                fetchPolicy: 'network-only'
            })));

            const merged = { total_students: [], fully_deliv_students: [], partly_deliv_students: [], not_deliv_students: [] };
            let any = false;
            results.forEach(r => {
                (r.data.getMaterialReport || []).forEach(row => {
                    any = true;
                    Object.keys(merged).forEach(k => merged[k].push(...(row[k] || [])));
                });
            });

            this.setState({ totalStudentsData: any ? [merged] : [], loader: 0, dashboard: true });
        } catch (err) {
            console.error("getMaterialReport error", err);
            this.setState({ totalStudentsData: [], loader: 0, dashboard: true });
        }
    };

    articlecolumns = [
        { dataField: "student_name", text: "Student Name", sort: true },
        { dataField: "roll_no", text: "Roll No.", sort: true },
        { dataField: "ecs", text: "Class / Section", sort: true },
        { dataField: "materials", text: "Material Quantity", formatter: this.materialData.bind(this), sort: true },
        { dataField: "materials_delivered", text: "Material Delivered", formatter: this.materialData.bind(this), sort: true },
        { dataField: "materials_pending", text: "Material Pending", formatter: this.materialData.bind(this), sort: true },
        { dataField: "materials_received", text: "Material Received", formatter: this.materialData.bind(this), sort: true },
        { dataField: "materials_not_received", text: "Material Not Received", formatter: this.materialData.bind(this), sort: true },
    ];

    materialData(val, row) {
        return (
            <div>
                {val.length > 0 ? (
                    <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ materialDetailsModal: true, rowData: val, selctedType: "" }) }}>{val.length}</a>
                ) : (val.length)}
            </div>
        )
    }

    tableData(data) {
        return data.map((mapData) => ({
            student_name: mapData.student_name,
            roll_no: mapData.roll_no,
            ecs: mapData.ecs,
            materials: mapData.materials,
            materials_delivered: mapData.materials_delivered,
            materials_pending: mapData.materials_pending,
            materials_received: mapData.materials_received,
            materials_not_received: mapData.materials_not_received,
        }));
    }

    render() {
        if (this.state.initialLoad) {
            return <MaterialPageShimmer filters={5} />;
        }

        const { classSearch, sectionSearch } = this.state;
        const classOptions = this.classOptions();
        const sectionOptions = this.sectionOptionsFor(classSearch);

        let materialData = [];
        if (this.state.totalStudentsData.length > 0) {
            const d = this.state.totalStudentsData[0];
            materialData = this.state.blockType == "1" ? d.total_students : this.state.blockType == "2" ? d.fully_deliv_students : this.state.blockType == "3" ? d.partly_deliv_students : d.not_deliv_students;
        }

        const statusCards = this.state.totalStudentsData.length > 0 ? [
            { key: "1", label: "Total Students", count: this.state.totalStudentsData[0].total_students.length, tint: "#eef2ff", border: "#c7d2fe", color: "#4f46e5" },
            { key: "2", label: "Fully Delivered", count: this.state.totalStudentsData[0].fully_deliv_students.length, tint: "#ecfdf5", border: "#a7f3d0", color: "#059669" },
            { key: "3", label: "Partially Delivered", count: this.state.totalStudentsData[0].partly_deliv_students.length, tint: "#fffbeb", border: "#fde68a", color: "#d97706" },
            { key: "4", label: "Not Delivered", count: this.state.totalStudentsData[0].not_deliv_students.length, tint: "#fef2f2", border: "#fecaca", color: "#dc2626" },
        ] : [];

        return (
            <div style={FIN.wrapper}>
                <Container fluid className="px-0">
                    <div style={FIN.card}>
                        <MaterialTabs active="report" />
                        <div style={FIN.cardHeader}>
                            <div style={FIN.iconWrapper}><i className="fal fa-file-alt" /></div>
                            <div style={FIN.cardTitleText}>
                                <h5 style={FIN.cardTitle}>Material Report</h5>
                                <span style={FIN.cardSubtitle}>Delivery status of materials issued to students</span>
                            </div>
                        </div>

                        <div style={FIN.filterBar}>
                            <Row className="g-2 align-items-end">
                                {/* No Branch filter — the header's branch selection scopes this report. */}
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Class</label>
                                    <CheckboxDropdown options={classOptions} value={classSearch} onChange={this.onClassChange} placeholder="Select Class(es)" />
                                    {this.state.classError ? <span style={FIN.err}>{this.state.classError}</span> : null}
                                </Col>
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Section</label>
                                    <CheckboxDropdown options={sectionOptions} value={sectionSearch} onChange={this.onSectionChange} placeholder="Select Section(s)" />
                                    {this.state.sectionError ? <span style={FIN.err}>{this.state.sectionError}</span> : null}
                                </Col>
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <label style={FIN.label}>Material Type</label>
                                    <select style={FIN.select} value={this.state.materialTypeSearch} onChange={this.onMaterialTypeChange}>
                                        <option value="0" disabled>Select Material Type</option>
                                        {this.state.materialTypeDetails.map(t => <option key={t.id} value={t.id}>{t.material_type}</option>)}
                                    </select>
                                    {this.state.materialTypeError ? <span style={FIN.err}>{this.state.materialTypeError}</span> : null}
                                </Col>
                                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                                    <button style={{ ...FIN.btnPrimary, width: "100%" }} onClick={this.handleSubmit}>
                                        <i className="fas fa-search" /> Get Report
                                    </button>
                                </Col>
                            </Row>
                        </div>

                        <div style={FIN.content}>
                            {this.state.loader == 1 ? (
                                <MaterialTableShimmer rows={6} cols={8} />
                            ) : this.state.dashboard && this.state.totalStudentsData.length > 0 ? (
                                <>
                                    <Row className="mb-3">
                                        {statusCards.map((c) => {
                                            const active = this.state.blockType == c.key;
                                            return (
                                                <Col xl={3} lg={3} md={6} sm={12} className="mb-2" key={c.key}>
                                                    <div onClick={() => this.setState({ blockType: c.key })} style={{ background: c.tint, border: `1.5px solid ${active ? c.color : c.border}`, borderRadius: 14, padding: "16px 18px", cursor: "pointer", textAlign: "center", transition: "all .15s ease" }}>
                                                        <div style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>{c.label}</div>
                                                        <div style={{ fontSize: 26, fontWeight: 800, color: c.color, lineHeight: 1.2 }}>{c.count}</div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                    {materialData.length > 0 ? (
                                        <CardLessDataTableWithSearch parentData={this.tableData(materialData)} particlecolumns={this.articlecolumns} name="attendance" />
                                    ) : (
                                        <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                                            <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-folder-open" /></div>
                                            <h6 style={{ color: "#64748b" }}>No data available</h6>
                                        </div>
                                    )}
                                </>
                            ) : this.state.dashboard && this.state.totalStudentsData.length == 0 ? (
                                <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                                    <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-folder-open" /></div>
                                    <h6 style={{ color: "#64748b" }}>No data available</h6>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>

                <MaterialDetailsModal
                    stateData={this.state}
                    show={this.state.materialDetailsModal}
                    onHide={() => this.setState({ materialDetailsModal: false })}
                />
            </div>
        )
    }
}

export default withRouter(withApollo(MaterialReportHome));
